export const ariaNewTab = (title: string) =>
  `${title} - link opens in a new tab`;
